import SuggestedItem from 'components/form/SuggestedTimes/SuggestedItem/styled';

export default SuggestedItem;
